import {
	getApiUrl,
	getUsersIdAvatarPath,
	type MarketResponseDto,
} from "Infrastructure/Api/Api";
import { useMarketListQuery } from "Market/Api/Query/useMarketListQuery";
import { useUserList } from "Settings/User/Api/Query/useUsersListQuery";
import ProfileImg from "Shared/Assets/Images/Profiles/user-1.jpg";
import { Avatar, Stack } from "@mui/material";
import { useMemo } from "react";

export const useManagerOptions = (
	primaryMarket: MarketResponseDto | null | undefined,
) => {
	const { data: users } = useUserList();
	const { data: markets } = useMarketListQuery();

	const managerOptions = useMemo(() => {
		if (!users || !markets) return [];

		const currentMarketId = primaryMarket?.id;
		const currentMarketName = primaryMarket?.name ?? "Unknown";

		const getMarketNameById = (id: number | null | undefined): string =>
			markets.find((m) => m.id === id)?.name ?? "Unknown";

		const marketLabelMap = new Map<number | null | undefined, string>();

		users.forEach((user) => {
			const marketId = user.preselectedMarketId;
			if (!marketLabelMap.has(marketId)) {
				if (marketId === currentMarketId) {
					marketLabelMap.set(marketId, currentMarketName);
				} else {
					marketLabelMap.set(marketId, getMarketNameById(marketId));
				}
			}
		});

		const options = users.map((user) => {
			const marketId = user.preselectedMarketId;
			const group = marketLabelMap.get(marketId) ?? "Unknown";

			return {
				value: user.id,
				label: `${user.name} ${user.surname}`,
				group,
				optionLabel: (
					<Stack key={user.id} direction="row" gap={1} alignItems="center">
						<Avatar
							src={
								user.avatarFileName
									? `${getApiUrl()}${getUsersIdAvatarPath(user.id)}`
									: ProfileImg
							}
							alt="user avatar"
							sx={{ width: 24, height: 24 }}
						/>
						{user.name} {user.surname}
					</Stack>
				),
			};
		});

		return options.sort((a, b) => {
			const orderMarketGroup = currentMarketName;

			if (a.group === b.group) return 0;
			if (a.group === orderMarketGroup) return -1;
			if (b.group === orderMarketGroup) return 1;

			return a.group < b.group ? -1 : 1;
		});
	}, [users, primaryMarket, markets]);

	return managerOptions;
};
